const qs_selectors = {
  modal: '[data-quickshop-modal]',
  modalContent: '[data-pxu-modal-content]',
  closeButton: '[data-quickshop-close]',
  buttons: '[data-quickshop-trigger]',
  overlay: '[data-quickshop-overlay]',
};
class ProductAddons extends HTMLElement {
  constructor() {
    super();
    this.init();

    this.productFamily = this.dataset.productFamily;

    window.addEventListener('variant:change', (container) => {
      this.init();
    });

    this.addEventListener('quickshop:reload', (container) => {
      let url = `${container.detail.url}&view=quickshop`;
      this.fetchProduct(url, false, container.detail.variant === 'Colour');
    });
  }

  init() {
    if (this.childElementCount > 0) {
      this.quickviewModal = document.querySelector(qs_selectors.modal);
      this.closeButton = this.quickviewModal.querySelector(qs_selectors.closeButton);
      this.quickviewOverlay = null;
      this.quickviewContent = document.querySelector(qs_selectors.modalContent);

      this.closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });

      this.querySelectorAll(qs_selectors.buttons).forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.productUrl = el.dataset.productUrl;
          this.fetchProduct(`${this.productUrl}?view=quickshop`, true);
        });
      });
    }
  }

  initDrawer() {
    var $drawerActive = this.dataset.drawerActive;
    var $moneyFormat = this.dataset.moneyFormat;
    if ($drawerActive) {
      jQuery(($) => {
        ajaxCart.init({
          formSelector: '[data-product-form]',
          cartContainer: '#CartContainer',
          addToCartSelector: '#AddToCart',
          cartCountSelector: '.CartCount',
          cartCostSelector: '.CartCost',
          moneyFormat: $moneyFormat,
        });
      });
      jQuery('body').on('ajaxCart.afterCartLoad', (evt, cart) => {
        // Bind to 'ajaxCart.afterCartLoad' to run any javascript after the cart has loaded in the DOM
        this.closeModal();
        timber.RightDrawer.open();
      });
    }
  }

  /*
   * @param {string} url - The url to fetch the product from
   * @param {boolean} open - Whether to open the modal for the first time
   * @returns {boolean} colorChange - If color change in quickshop, replace the quickshop content altogether
   */

  fetchProduct(url, open, colorChange) {
    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        if (this.quickviewContent !== null) {
          const parser = new DOMParser();

          if (open || colorChange) {
            this.openModal();
            const productHTML = parser.parseFromString(response, 'text/html').getElementById('product-details');
            const productDesc = productHTML.querySelector('.tabbed-block');
            if (productDesc) {
              productDesc.classList.add('hide');
            }
            this.quickviewContent.innerHTML = productHTML.innerHTML;
            this.updateTabs();
          } else {
            const productHTML = parser.parseFromString(response, 'text/html').getElementById('sticky-container');
            const productDetails = this.quickviewContent.querySelector('#sticky-container');
            if (productDetails != null) {
              productDetails.innerHTML = productHTML.innerHTML;
            }
          }

          var context = document.querySelector('.product-quick-shop');
          window.dispatchEvent(new CustomEvent('quickshop:load', { detail: context }));
          this.initDrawer();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  openModal() {
    this.quickviewModal.classList.add('open');
    document.body.classList.add('quickshop-active');
    this.quickviewOverlay = document.querySelector(qs_selectors.overlay);
    this.quickviewOverlay.addEventListener('click', (e) => {
      this.closeModal();
    });
    this.quickviewOverlay.classList.add('open');
  }

  closeModal() {
    document.body.classList.remove('quickshop-active');
    this.quickviewModal.classList.remove('open');
    this.quickviewContent.innerHTML = '';
    this.quickviewOverlay.classList.remove('open');
  }

  //TODO: Remove this when the tabs are migrated from Stations

  updateTabs() {
    this.Tabs = window.Station.Apps.Tabs;
    const description = this.quickviewContent.querySelector('.product-description');

    if (description) {
      const tabbedBlock = description.querySelector('.tabbed-block');
      const link = description.parentElement.querySelector("a[href^='/products']");

      if (link && tabbedBlock) {
        var url = 'https://' + window.Shopify.shop + '/products/' + link.getAttribute('href').split('/').pop();

        this.getProTabsHTML(url)
          .then((result) => {
            var proTabs = document.createElement('div');
            proTabs.classList.add('station-tabs-tabset');
            proTabs.insertAdjacentHTML('beforeend', result);
            tabbedBlock.insertAdjacentElement('beforeend', proTabs);
            this.Tabs.createInstance(tabbedBlock);
          })
          .catch(function (error) {
            console.log(error);
          });
      }

      setTimeout(() => {
        tabbedBlock.classList.remove('hide');
      }, 500);
    }
  }

  getProTabsHTML(url) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.Tabs.fetchElements(url, {
        queryString: '#station-tabs-data-json',
      })
        .then(function (result) {
          if (!result[0]) return;
          var data = JSON.parse(result[0]?.textContent);
          resolve(data.proTabsHTML);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}

customElements.define('product-addons', ProductAddons);
